export class PartnerHostnameProvider {
  static get hostname(): string {
    const { searchParams } = new URL(location.href);
    const partnerHostname = searchParams.get('partnerHostname');
    const isDevEnv = location.hostname === 'localhost';

    if (!partnerHostname && !isDevEnv) {
      console.warn('WARNING: The "partnerHostname" query param is missing. Will fall back to "no-iframe".');
      return 'no-iframe';
    }

    return partnerHostname;
  }
}
